import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import {
  motion,
  useMotionTemplate,
  useScroll,
  useTransform,
} from "framer-motion";
import Reveal from "../components/reveal";

const Service = ({ title, desc, img, new_or_not, link_to_solution, index }) => {
  return (
    <div className="px-8 flex flex-col md:flex-row md:items-center alternateFlex my-8 md:my-20 justify-between max-w-6xl mx-auto md:gap-x-6">
      <div className="md:w-2/5">
        <div className="flex flex-col">
          <h5 className="text-3xl md:text-3xl font-light opacity-40 text-white">
            0{index + 1}
          </h5>
        </div>
        <div className="flex items-center mb-2">
          <h5 className="text-white text-2xl mb-3">{title}</h5>
        </div>
        <Reveal once={false} dur={0.6} threshold={1}>
          <p className="md:max-w-sm text-xl md:text-lg mb-4 md:mb-4 text-white antialiased">
            {desc}
          </p>
          {link_to_solution.link_type === "Document" ? (
            <Link
              className="rounded-full border-white block w-max border mb-4 md:mb-0 px-3 pb-2 pt-1.5 text-white text-sm font-medium"
              to={`solution/${link_to_solution.uid}`}
            >
              Learn More
            </Link>
          ) : (
            <a
              className="rounded-full border-white block w-max border mb-4 md:mb-0 px-3 pb-2 pt-1.5 text-white text-sm font-medium"
              target="_blank"
              rel="noopener noreferrer"
              href={link_to_solution.url}
            >
              Learn More
            </a>
          )}
        </Reveal>
      </div>
      <Reveal
        once={false}
        dur={0.6}
        threshold={0.5}
        y={20}
        className="md:max-w-lg md:w-3/5 w-full"
      >
        <GatsbyImage image={img} className="rounded-lg" />
      </Reveal>
    </div>
  );
};

export default function Services({ slice }) {
  const refScroll = React.useRef(null);
  const { scrollYProgress } = useScroll({
    target: refScroll,
    offset: ["start end", "start start"],
  });

  let animateSmile = useTransform(scrollYProgress, [0, 1], [2, 90]);
  let smile = useMotionTemplate`ellipse(60% ${animateSmile}% at center top)`;

  // const smileVariants = {
  //   initial: {
  //     clipPath: "ellipse(60% 2% at center top",
  //     transition: { duration: 0.4 },
  //   },
  //   animate: {
  //     clipPath: "ellipse(60% 90% at center top",
  //     transition: { duration: 0.5, delay: 0.2 },
  //   },
  //   exit: {
  //     clipPath: "ellipse(55% 100% at center top",
  //     transition: { duration: 0.4 },
  //   },
  // };

  return (
    <div className="bg-blue -mt-6">
      <motion.div
        ref={refScroll}
        style={{
          clipPath: smile,
        }}
        className=" bg-white h-60 md:h-72 pt-16 md:pt-1"
      >
        <motion.h1 className="max-w-sm mt-6 md:max-w-xl text-bg-dark text-center text-4xl md:text-6xl mx-auto font-bold">
          Everything you need out of the box
        </motion.h1>
      </motion.div>
      <div className="from-blue via-blue-700 to-blue-900 bg-gradient-to-b pt pb-12">
        {slice.items.map(
          (
            { description, link_to_solution, title, image, new_or_not },
            index
          ) => (
            <Service
              key={index}
              index={index}
              title={title.text}
              desc={description.text}
              img={image.gatsbyImageData}
              new_or_not={new_or_not}
              link_to_solution={link_to_solution}
            />
          )
        )}
      </div>
    </div>
  );
}
